// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"334":"app-theme-dark1","522":"app-theme-dark0","554":"app-theme-light1","641":"app-theme-light0"}[chunkId] + "." + {"334":"1f2b3a3d","522":"7622c686","554":"7aa723e2","641":"19c0ba46"}[chunkId] + ".chunk.css";
};